import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user\"><path d=\"M626.24 559.04a262.72 262.72 0 1 0-242.56 0C96 631.04 82.56 955.2 82.56 960l64 1.92c0-14.4 14.72-352 358.4-352s371.52 339.2 372.48 353.6l64-4.48c-0.32-4.8-25.92-328-315.2-400z m-320-232.64a198.72 198.72 0 1 1 198.72 198.4 198.72 198.72 0 0 1-198.72-198.4z\" p-id=\"6454\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol